import { createSelector } from 'reselect';

export const getTopTrendingTags = (state) => state?.widgets?.topTrendingTags;

const COLORS_SET = ['#A9D134', '#E0529C', '#33BCB7', '#5273E0', '#E8D639'];

export const selectTrendingTags = createSelector(
  [getTopTrendingTags],
  (tags) => {
    if (!tags) return null;

    const labels = Object?.keys(tags)?.sort(
      (a, b) => new Date(a) - new Date(b),
    );
    const datasetsByTag = {};
    labels.forEach((dateKey, dateIndex) => {
      tags[dateKey].forEach((tag) => {
        datasetsByTag[tag?.tag_name] =
          datasetsByTag[tag?.tag_name] || new Array(labels?.length)?.fill(0);
        datasetsByTag[tag?.tag_name][dateIndex] = tag?.iocs_marked;
      });
    });

    return {
      labels,
      datasets: Object?.keys(datasetsByTag)?.map((tagName, index) => ({
        lineTension: 0,
        label: tagName,
        data: datasetsByTag[tagName],
        fill: false,
        backgroundColor: COLORS_SET[index % COLORS_SET?.length],
        borderColor: COLORS_SET[index % COLORS_SET?.length],
      })),
    };
  },
);
